<template>
  <div>
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="goback" size="0.4rem" />
          </div>
          <div style="text-align: center; font-size: 0.35rem">物业投诉</div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <van-form :scroll-to-error="true">
      <van-field v-model="communityName" type="text" label="所属小区:" placeholder="请输入小区名称" maxlength="10">
        <template #button>
          <van-button size="small" type="primary" @click="queryCommunityName">查询</van-button>
        </template>
      </van-field>
      <van-popup v-model="communityNamePicker" position="bottom">
        <van-picker show-toolbar value-key="wyqymc" :columns="communityNameList" @confirm="communityNameConfirm"
          @cancel="communityNamePicker = false" />
      </van-popup>
      <van-field readonly v-model="districtName" type="text" label="所属县区:" placeholder="请输入县区" maxlength="10" />
      <van-field readonly v-model="streetName" type="text" label="所属街道:" placeholder="请输入街道" maxlength="10" />
      <van-field readonly v-model="propertyName" type="text" label="物业公司:" placeholder="请输入物业公司" maxlength="10" />
      <van-field readonly clickable v-model="typeIdName" type="text" label="投诉类型:" placeholder="请选择投诉类型"
        @click="typeIdNamePicker = true" />
      <van-popup v-model="typeIdNamePicker" position="bottom">
        <van-picker show-toolbar :columns="typeIdNameList" @confirm="typeIdNameConfirm"
          @cancel="typeIdNamePicker = false" />
      </van-popup>
      <!-- <van-field
        readonly
        clickable
        v-model="typeId2Name"
        type="text"
        label="类型描述:"
        placeholder="请选择"
      /> -->
      <!-- <van-popup v-model="typeId2NamePicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="text"
          :columns="typeId2NameList"
          @confirm="typeId2NameConfirm"
          @cancel="typeId2NamePicker = false"
        />
      </van-popup> -->
      <van-cell-group>
        <van-field v-model="content" rows="3" autosize label="投诉内容:" type="textarea" placeholder="请输入投诉内容"
          maxlength="50" show-word-limit />
      </van-cell-group>
      <van-field name="uploader" label="上传图片:">
        <template #input>
          <van-uploader v-model="uploadImg" @delete="deleteImg" :after-read="beforeRead" name="uploadImgId" />
        </template>
      </van-field>
      <div style="margin: 16px; padding-bottom: 16px">
        <van-button block type="info" @click="onSubmit" :disabled="isDisabled">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import qs from "qs";
export default {
  data() {
    return {
      isSubmit: true,
      communityId: "",
      communityName: "",
      communityNameList: [],
      communityNamePicker: false,
      districtName: "",
      streetName: "",
      propertyName: "",
      typeIdName: "",
      typeId1Name: "",
      typeId1: "",
      typeId2: "",
      typeIdNameList: [],
      typeIdNamePicker: false,
      typeId2Name: "",
      content: "",
      isDisabled: false,
      uploadImg: [],
      uploadImgId: [],
      isApp: this.$route.query.isApp || false,
      isWx: this.$route.query.isWx || false,
      wxAppToken: sessionStorage.getItem("wxAppToken") || "",
      token: "",
      tab: 0,
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
    };
  },
  created() { },
  mounted() {
    this.assignmentTooken();
    this.complaintsType();
  },
  methods: {
    typeIdNameConfirm(item, index) {
      if (item[1]) {
        this.typeIdName = item[0] + "—" + item[1];
        this.typeId1Name = item[0];
        this.typeId2Name = item[1];
        this.typeId1 = this.typeIdNameList[index[0]].id;
        this.typeId2 = this.typeIdNameList[index[0]].children[index[1]].id;
      } else {
        this.typeIdName = item[0];
        this.typeId1Name = item[0];
        this.typeId1 = this.typeId1 = this.typeIdNameList[index[0]].id;
      }
      this.typeIdNamePicker = false;
    },
    complaintsType() {
      var item = {
        appToken: this.token,
      };
      this.$http
        .post("house/wyts/getComplaintsType.do", qs.stringify(item))
        .then((res) => {
          if (res.success) {
            for (var i = 0; i < res.obj.length; i++) {
              if (res.obj[i].children.length == 0) {
                res.obj[i].children.push({ text: "" });
              }
            }
            this.typeIdNameList = res.obj;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    communityNameConfirm(item, index) {
      this.communityId = this.communityNameList[index].wyqydm;
      this.districtId = this.communityNameList[index].xzqybm;
      this.streetId = this.communityNameList[index].jdbjgzj;
      this.propertyId = this.communityNameList[index].jgdm;
      this.districtName = item.xzqymc;
      this.communityName = item.wyqymc;
      this.streetName = item.jdbjgmc;
      this.propertyName = item.jgmc;
      this.communityNamePicker = false;
    },
    queryCommunityName() {
      var item = {
        appToken: this.token,
        xqmc: this.communityName,
      };
      this.$http
        .post("house/wyts/getXqList.do", qs.stringify(item))
        .then((res) => {
          if (res.success) {
            this.communityNamePicker = true;
            this.communityNameList = res.obj;
          } else {
            this.communityNamePicker = true;
            this.$toast(res.msg);
          }
        });
    },
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break;
          }
        }
        this.token = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.token = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.token = JSON.parse(localStorage.getItem("tokenObj")).appToken;
          }
        }
      }
    },
    onSubmit() {
      var obj = {
        communityId: this.communityId,
        districtName: this.districtName,
        districtId: this.districtId,
        communityName: this.communityName,
        streetName: this.streetName,
        streetId: this.streetId,
        propertyName: this.propertyName,
        propertyId: this.propertyId,
        typeId1Name: this.typeId1Name,
        typeId2Name: this.typeId2Name,
        typeId1: this.typeId1,
        typeId2: this.typeId2,
        content: this.content,
      };
      var item = {
        appToken: this.token,
        imgIdList: this.uploadImgId,
        complaints: JSON.stringify(obj),
      };
      if (this.isSubmit) {
        this.isSubmit = false
        this.$http
          .post("house/wyts/propertyComplaintsAdd.do", qs.stringify(item))
          .then((res) => {
            this.isSubmit = true
            if (res.success) {
              this.$toast(res.msg);
              this.$router.go(-1)
            } else {
              this.$toast(res.msg);
            }
          });
      }

    },
    goback() {
      this.$router.go(-1);
    },
    beforeRead(file, detail) {
      if (file.content == "") {
        this.$toast("机型或版本过低，相机不可用，请从相册图片上传");
      } else {
        this.saveImg(file, detail);
      }
    },
    createImage(file, detail) {
      let reader = new FileReader();
      let self = this;
      reader.onload = (e) => {
        let result = e.target.result;
        let img = new Image();
        img.src = result;
        self.saveImg(file.content, detail);
        // if (result.length / 1024 > 30) {
        //   img.onload = function () {
        //     //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
        //     // file.content = self.compress(img, 0.5);
        //     self.saveImg(file.content, detail);
        //   };
        // } else {
        //   file.content = result;
        //   self.saveImg(file.content, detail);
        // }
      };
      // 读取图像
      reader.readAsDataURL(file.file);
    },
    //删除图片
    deleteImg(file, detail) {
      this.$data[detail.name].splice(detail.index, 1);
    },
    saveImg(imgData, detail) {
        var item = {
        image: imgData.file,
        appToken: this.token,
      };
      var form = new FormData();
      for (var key in item) {
        form.append(key, item[key]);
      }
      this.$http
        .post("house/wyts/complaintsPicAdd.do", form, {
          headers: {
            processData: false,
            contentType: false,
          },
        })
        .then((res) => {
          if (res.success) {
            this.$data[detail.name].push(res.obj);
          } else {
            this.$toast("保存失败,请重新上传");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}

.tab_con {
  height: 1rem;
  background-color: #fff;
  z-index: 9;

  span {
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    text-align: center;
  }

  .active {
    color: #3072f5;
    position: relative;
    font-size: 0.33rem;

    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      margin-left: -0.2rem;
      background-color: #3072f5;
      width: 0.4rem;
      height: 0.04rem;
    }
  }
}

.saveDraft {
  padding: 0.1rem 0.15rem;
  font-size: 0.2rem;
  border-radius: 0.1rem;
  border: 1px solid #007fff;
  color: #007fff;
}

.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;

  .top_normal {
    height: 100%;

    i {
      font-size: 0.32rem;
    }
  }
}

.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
</style>
